import { flex } from '../../../styled-system/patterns';
import { EmailChange } from '#/features/emailChange/components/EmailChange';
import { useChangeForm } from '#/features/emailChange/hooks/useChangeForm';
import { EmailChangeComplete } from '#/features/emailChange/components/EmailChangeComplete';
import { useTitle } from '#/utils/useTitle';
import { useLoginRequired } from '#/utils/auth/useLoginRequired';

export function EmailChangePage() {
  useLoginRequired();
  useTitle('メールアドレス変更');
  const { onSubmit, isSuccess, register, formState } = useChangeForm();
  return (
    <div
      className={flex({ alignItems: 'center', padding: '{spacing.20} {spacing.16}', sm: { padding: '{spacing.80}' } })}
    >
      {/* TODO: メール送信に失敗した場合にエラーページを表示する実装は別途作成 */}
      {isSuccess ? (
        <EmailChangeComplete />
      ) : (
        <EmailChange onSubmit={onSubmit} register={register} formState={formState} />
      )}
    </div>
  );
}
